module.exports = __webpack_public_path__ + "static/media/westside_thumb_even.bf594b5a.jpg";